import { useContext, useEffect, useState } from "react";

import { CorePropsInterfaces } from "src/core/Models";
import { TextField } from "@mui/material";
import * as Constants from "src/core/Constants";
import { AppContext } from "src/contexts/AppContext";
import { formatSwedishPostalCode, getCompanyAddressCountry } from "src/utils";

function QuestionReadonlyInput({
  question,
}: CorePropsInterfaces.QuestionInputProps) {
  const { globalState } = useContext(AppContext);
  const [fieldValue, setFieldValue] = useState(question.data.userValue);

  useEffect(() => {
    setFieldValue(question.data.userValue);
  }, [question.data.userValue]);

  const displayValue =
    question.data.code === Constants.GeneralInformationQuestion.Q0020
      ? formatSwedishPostalCode(
          fieldValue as string,
          getCompanyAddressCountry(globalState.remoteData?.companyDetails)
        )
      : fieldValue;

  return (
    <TextField
      data-testid={question.data.code}
      className="gt-TextField"
      disabled={true}
      value={displayValue || ""}
      variant="outlined"
    />
  );
}

export default QuestionReadonlyInput;
